import { Core, CoreInitOptions } from '@voximplant/websdk';

let coreInstance: Core | null = null;

export function getCore(): Core {
    if (!coreInstance) {
        throw new Error('Core не инициализирован. Вызовите initializeCore() сначала.');
    }

    return coreInstance;
}

export function initializeCore(options: CoreInitOptions): Core {
    if (!coreInstance) {
        coreInstance = Core.init(options);
    }

    return coreInstance;
}

export function isCoreInitialized(): boolean {
    return coreInstance !== null;
}
